import { Component, Inject } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

/**
 * @title Snack-bar with a custom component
 */
@Component({
  selector: 'snack-bar-component',
  template: `<div class="snack-content">
    <div class="snack-info">
      <span class="info-icon"><mat-icon>info</mat-icon></span>
      <span>{{ data }}</span>
    </div>
    <span class="cancel-snack">
      <mat-icon (click)="snackBarRef.dismiss()">close</mat-icon>
    </span>
  </div>`,
  styles: [
    `
      .snack-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        overflow: hidden;
      }

      .snack-info {
        display: flex;
        align-items: center;
      }

      .info-icon {
        margin-right: 1rem;
      }

      .cancel-snack {
        cursor: pointer;
      }

      ::ng-deep .mat-mdc-snack-bar-container .mat-mdc-snackbar-surface {
        background-color: #edfcf2 !important;
        color: #05bf04 !important;
      }
    `,
  ],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatSnackBarModule],
})
export class SnackBarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: string,
  ) {}
}
